import { render, staticRenderFns } from "./AdminBarView.vue?vue&type=template&id=4f4e3285&"
import script from "./AdminBarView.vue?vue&type=script&lang=ts&"
export * from "./AdminBarView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports